import { configureAuth } from 'lib/react-query-auth';
import { userFn, loginFn, tokenFn, registerFn, logoutFn } from '../utils/token';

// Forms-based auth hooks
export const formsHooks = configureAuth({
  userFn,
  loginFn,
  tokenFn,
  registerFn,
  logoutFn,
});

export const { useLogin, useCompanySelect, useLogout, useUser } = formsHooks;
